import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleConfirmationModal } from './confirmationModalActions';
import { getTranslate } from 'react-localize-redux';
import './confirmationModal.less'
import { Button } from 'antd';

const ErrorModalContent = () => {
  const dispatch = useDispatch();
  const translate = getTranslate(useSelector(state => state.localize));
  const showingConfirmationModal = useSelector(state => state.confirmation.showingConfirmationModal);

  useEffect(() => {
    if(showingConfirmationModal) {
      // replace with the code from `componentWillReceiveProps` if there's any
    }
  }, [showingConfirmationModal]);

  return (
    <>
      <div className='confirm-modal-content-container'>
          <div className='confirm-content-image-container confirm-error-content-image'>
          </div>
          <div className='confirm-content-container'>
              <p className='confirm-content-title'>
                  {translate('confirmationModal.ovo_admin_heading_failed_to_save_changes')}
              </p>
              <p className='confirm-content'>
                  {translate('confirmationModal.ovo_admin_body_failed_to_save_changes')}
              </p>
              <div className='confirm-modal-content-container confirm-modal-buttons'>
                <Button type="secondary" onClick={() => dispatch(toggleConfirmationModal())}>
                  {translate("confirmationModal.button_cancel")}
                </Button>
            </div>
          </div>
      </div>
    </>
  );
};

export default ErrorModalContent;